module.exports = __webpack_public_path__ + "img/poland.868fadc6.png";